import { useState, useEffect } from 'react';

import Box from '@mui/material/Box';

import Grid from '@mui/material/Unstable_Grid2'; // Grid version 2

import { OpenSwal } from '../Utils';

import { useNavigate } from 'react-router-dom';
import { Button } from '@mui/material';



import List from '@mui/material/List';
import Typography from '@mui/material/Typography';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import { Avatar } from '@mui/material';
import { Stack } from '@mui/material';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import LinearProgress from '@mui/material/LinearProgress';
import HomeOutlinedIcon from '@mui/icons-material/HomeOutlined';
import { Chip } from '@mui/material';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import InfiniteScroll from 'react-infinite-scroll-component';
import { url_get_bell_notification_messages } from '../RoutesMap';
import { apiWithAuth } from '../Services/Axios/axios';


function NotificationListComp(props) {

    return (<Box sx={{ mb: 2 }}>

        <Box sx={{ backgroundColor: '#fbfbfb', borderRadius: 2, mb: 3 }}>
            <ListItem  >
                <ListItemAvatar>
                    <Avatar></Avatar>
                </ListItemAvatar>
                <ListItemText disableTypography={true}
                    primary={<Stack direction='row' spacing={1}><Typography fontWeight="bold" variant='subtitle1'>{props.heading}</Typography> {props.status === 1 && <Chip label='New' icon={<AutoAwesomeOutlinedIcon />} color="secondary" size='small' />}</Stack>}
                    secondary={null}
                />
            </ListItem>
            <Box sx={{ ml: 2, }} >
                <Typography variant='subtitle1'>{props.body}</Typography>
                <Box sx={{ mt: 0.3 }}>

                    {props.subtitle.subtitle_heading && <Stack direction='row' spacing={0.5}><Typography color="black" variant='subtitle2' fontWeight='bold'>{props.subtitle.subtitle_heading}:</Typography> <Typography variant='subtitle2' fontWeight="normal">{props.subtitle.subtitle_value}</Typography></Stack>}
                    <Stack direction='row' spacing={0.5}><Typography color="black" variant='subtitle2' fontWeight='bold' >Added Date: </Typography> <Typography variant='subtitle2' fontWeight="normal">{props.addedDate}</Typography></Stack>
                </Box>
                <Box sx={{ height: 10 }}>

                </Box>
            </Box>


        </Box>
    </Box>
    );
}

function NotificationLists({ PusherDashboardTrigger }) {
    const [NotificationListAry, NotificationListArySet] = useState([]);
    const [NotificationListAryStatus, NotificationListAryStatusSet] = useState(false);

    const [hasMore, setHasMore] = useState(true);
    const [index, setIndex] = useState(0);



    const navigate = useNavigate();
    const appThemeColor = "#" + process.env.REACT_APP_THEME_COLOR;

    const appThemeSecondaryColor = process.env.REACT_APP_THEME_SECONDARY_COLOR;


    const LoadNotificationList = (status) => {
        let assign_data;
        if (status === 'limit') {
            assign_data = { status: 'limit' }
        } else if (status === 'limit_set') {
            assign_data = { status: 'limit', last_id: index }

        }
        apiWithAuth.post(url_get_bell_notification_messages, assign_data, { headers: { "Content-Type": "multipart/form-data" } }).then(response => {
            if (response.data.status) {
                if (status === 'limit') {
                    NotificationListArySet(response.data.data);
                } else if (status === 'limit_set') {
                    NotificationListArySet((prevItems) => [...prevItems, ...response.data.data]);
                }

                setIndex(response.data.last_id);
                if (response.data.all_count > 10) {
                    response.data.data.length > 0 ? setHasMore(true) : setHasMore(false);
                } else {
                    setHasMore(false);
                }

                NotificationListAryStatusSet(true);
            } else if (response.data.status === false && response.data.message === "Token Expired") OpenSwal('Token_error', navigate);
            else {
                OpenSwal('Axios_error', response.data.message);
            }
        });
    }

    useEffect(() => {
        LoadNotificationList('limit');
    }, [PusherDashboardTrigger])

    const GoBackDashboard = () => {
        navigate('/Interpreter/Dashboard');
    }


    return (
        <Box>

            <Box>
                <Grid container spacing={1}>
                    <Grid xs={10} sm={10} md={10}>
                        <Box >
                            <Typography sx={{ typography: { xs: 'subtitle1', sm: 'body1', md: 'h6' } }} color={appThemeColor} style={{ fontWeight: 'bold', textDecoration: 'underline', textDecorationThickness: '3px', textUnderlineOffset: '6px' }} >All Notification list</Typography>
                        </Box>
                    </Grid>
                    <Grid xs={2} sm={2} md={2}>

                        <Box sx={{ display: 'flex', justifyContent: 'right' }}>
                            <Button startIcon={<HomeOutlinedIcon sx={{ mr: -1, fontSize: '2px' }} />} onClick={GoBackDashboard} sx={{ textDecoration: 'underline', textTransform: 'none', color: appThemeColor }} >Dashboard</Button>
                        </Box>
                    </Grid>

                </Grid>

            </Box>
            <Box sx={{ mt: 1, mb: 8 }}>
                <InfiniteScroll
                    dataLength={NotificationListAry.length}
                    next={() => LoadNotificationList('limit_set')}
                    hasMore={hasMore}
                    loader={<Box sx={{ mt: 5, mb: 5, display: 'flex', justifyContent: 'center' }}><LinearProgress color={appThemeSecondaryColor} sx={{ width: '70%', alignItems: 'center' }} /></Box>}
                    endMessage={
                        <Box sx={{ mt: 1, mb: 2 }}>
                            <Typography color={appThemeColor} fontWeight="bold" sx={{ textAlign: 'center' }}>
                                No notifications found!
                            </Typography>
                        </Box>
                    }

                    refreshFunction={() => LoadNotificationList('limit')}
                    pullDownToRefresh
                    pullDownToRefreshThreshold={100}
                    pullDownToRefreshContent={<Typography color={appThemeColor} variant='h6' fontWeight="bold" sx={{ textAlign: 'center' }}>
                        &#8595;Pull down to refresh
                    </Typography>

                    }
                    releaseToRefreshContent={<Typography color={appThemeColor} variant='h6' fontWeight="bold" sx={{ textAlign: 'center' }}>
                        &#8593; Release to refresh
                    </Typography>

                    }
                >
                    {(NotificationListAry.length !== 0 && NotificationListAryStatus) && <Box  >
                        <List >
                            {NotificationListAry.map((data, key) => {
                                return (<NotificationListComp key={key} heading={data.header_name} notification_id={data.notification_id} body={data.notification_message} subtitle={data.subtitle_array} status={data.status} addedDate={data.added_date_user} />)

                            })}
                        </List>
                    </Box>}
                </InfiniteScroll>

            </Box>

        </Box>
    )
}

export default NotificationLists